module.exports = __webpack_public_path__ + "2c3b3faf84c440e65feba3af45cf2f6e.ttf";